/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Connection_RevokedInputs */



/**
* | output |
* | --- |
* | "Access to the connected workspace was revoked. Reconnect it and try again." |
*
* @param {Embedding_Error_Connection_RevokedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_connection_revoked = /** @type {((inputs?: Embedding_Error_Connection_RevokedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Connection_RevokedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Zugriff auf den verbundenen Workspace wurde entzogen. Verbinden Sie ihn erneut und versuchen Sie es noch einmal.")
	return /** @type {LocalizedString} */ ("Access to the connected workspace was revoked. Reconnect it and try again.")
});